import { displayDateBrazilian } from '../../util/standardizedDate'

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}

const formattedValue = (value: number) => {
  const formattedValue = value.toFixed(1)

  return String(formattedValue).replace('.', ',')
}

export const parseLogisticKpiData = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'data-execucao-id': item.periodo ? formattedDate(item.periodo) : 0,

          'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
          'cd-loja-nome-id': item.lojaDescricao ? item.lojaDescricao : '',

          'gerente-categoria-id': item.gerenteCategoriaDescricao
            ? item.gerenteCategoriaDescricao
            : '',
          'gerente-produto-id': item.gerenteProdutoDescricao
            ? item.gerenteProdutoDescricao
            : '',

          'categoria-compacta-codigo-id': item.categoriaCompactaId
            ? item.categoriaCompactaId
            : 0,
          'categoria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-nome-id': item.empresaDescricao ? item.empresaDescricao : '',

          'fornecedor-id': item.fornecedorId ? item.fornecedorId : 0,
          'fornecedor-descricao-id': item.fornecedorDescricao
            ? item.fornecedorDescricao
            : '',

          'quantidade-pedidos-id': item.pedidosUltimosDozeMeses
            ? formattedValue(item.pedidosUltimosDozeMeses)
            : 0,
          'quantidade-sku-pedido-id': item.skUsMedioPorPedido
            ? formattedValue(item.skUsMedioPorPedido)
            : 0,

          'recebimentos-antes-prazo-id': item.proporcaoEntregaAntesPrazoFinal
            ? formattedValue(item.proporcaoEntregaAntesPrazoFinal)
            : 0,
          'recebimentos-prazo-id': item.proporcaoEntrega
            ? formattedValue(item.proporcaoEntrega)
            : 0,
          'recebimentos-depois-prazo-id': item.proporcaoEntregaAposPrazoFinal
            ? formattedValue(item.proporcaoEntregaAposPrazoFinal)
            : 0,
          'recebimentos-parciais-id': item.entregaParcial
            ? formattedValue(item.entregaParcial)
            : 0,
          'recebimentos-in-full-id': item.entregaCompleta
            ? formattedValue(item.entregaCompleta)
            : 0,

          'lead-time-cadastrado-id': item.tempoExecucaoSistema
            ? item.tempoExecucaoSistema
            : 0,
          'lead-time-realizado-id': item.tempoRealizado
            ? item.tempoRealizado
            : 0,
          'lead-time-desvio-id': item.diferencaRealizadaExecucaoSistema
            ? item.diferencaRealizadaExecucaoSistema
            : 0,
          'lead-time-porc-desvio-id': item.diferencaRealizadaProporcaoTempo
            ? formattedValue(item.diferencaRealizadaProporcaoTempo)
            : 0,
          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : ''
        }
      })
}
